import { ReadSearchApiArg, ReadSearchApiResponse } from 'lib-search-types';

import { ajaxSend } from '../../../api/api';
import { containsNumber } from '../../../app/utils/telephonyHelpers';

export async function searchUsers(
  payload,
): Promise<ReadSearchApiResponse<'users'>> {
  let query = payload.search;

  if (containsNumber(query)) {
    query = query.replace(/[^0-9+\s]/g, '');
  }

  const response = await ajaxSend<ReadSearchApiResponse<'users'>>({
    path: `/v4/search/users`,
    method: 'POST',
    data: {
      scope: 'users',
      query,
      filters: {
        strategy: 'all',
        filters: [
          {
            field: 'phone_number',
            operator: 'is_not_empty',
            values: [],
          },
        ],
      },
      pageSize: 5,
    } satisfies ReadSearchApiArg<'users'>,
  });

  return response;
}

export function getToken(payload?: { region?: string }) {
  return ajaxSend({
    method: 'PUT',
    path: '/v1/twilio/token',
    params: payload,
  });
}

export function setMute(payload) {
  const { csid, setTo } = payload;
  return ajaxSend({
    method: 'PUT',
    path: '/v1/conversations/' + csid + '/mute',
    data: {
      mute: setTo,
    },
  });
}

export function setHold(payload) {
  const { csid, setTo, requesterId } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${csid}/hold`,
    data: {
      hold: setTo,
      userId: requesterId,
    },
  });
}

export function getAllCountryCodes() {
  return ajaxSend({
    path: '/v1/available-countries',
  });
}

export function getAllNumbers() {
  return ajaxSend({
    path: '/v1/numbers',
  });
}

export function getQueryNumbers(payload) {
  const { query } = payload;
  let path = query && query.path ? query.path : null;
  const limit = query && query.limit ? 'limit=' + query.limit : 'limit=15';
  const count = query && query.count ? '&count=' + query.count : '';
  const after =
    query && query.after ? '&after=' + encodeURIComponent(query.after) : '';
  const before =
    query && query.before ? '&before=' + encodeURIComponent(query.before) : '';
  const search = query && query.search ? '&search=' + query.search : null;

  if (path === null && search === null) {
    path = '/v1/numbers?' + limit + count + after + before;
  } else if (path === null && search) {
    path = '/v1/numbers?' + limit + count + after + before + search;
  }

  return ajaxSend({
    path: path,
  });
}
